import { useState } from "react";
import { useLazyFetchHubwiseTransactionExceptionsQuery } from "../../../services/headofficeadmin";

const useHubwiseTransactions = () => {

    const [fetchTrigger, { data, isError, error, isFetching }] = useLazyFetchHubwiseTransactionExceptionsQuery();

    const { pagination, results } = data || { results: [], pagination: { totalCount: 100, page: 0, pageSize: 20, totalPages: null } };
    const { totalCount, page, pageSize: limit } = pagination;

    const [isClearing, setIsClearing] = useState(false);

    const clear = async () => {
        if (isFetching)
            return;
        setIsClearing(true);
        await fetchTrigger({ page: 1, limit })
            .unwrap()
        setIsClearing(false);
    };

    const isRowLoaded = (index) => (index < results.length) || isClearing;

    const loadMore = () => {
        if (page === 0)
            return clear();
        else
            return fetchTrigger({ page: page + 1, limit }).unwrap();
    };

    const reload = (e) => {
        e && typeof (e.preventDefault) === 'function' && e.preventDefault();

        clear();
    }

    return {
        results: isClearing ? [] : results,
        totalCount,
        isClearing,
        isError,
        error,
        isRowLoaded,
        loadMore,
        reload
    };
}

export default useHubwiseTransactions;